import { $axios, useAuthTokenError } from '../utils'
import { validateSignup, validateLogin, validateResetPassword, validateInviteUser } from '../validators/auth.validators'

/**
 * @description Get user object
 * @param {string} authToken
 */
export function getUser (authToken) {
  if (!authToken) throw new Error('No authToken provided for authenticated route')
  return $axios('/users/me', {
    method: 'GET',
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Sign up a user service
 * @param {{ firstName: String, lastName: String, email: String, password: String, confirmPAssword: String }} payload Create user payload
 */
export function signupUser (payload) {
  validateSignup(payload)
  return $axios.post('/auth/signup', {
    ...payload
  })
}

/**
 * Logs in a user
 * @param {{ email: String, password: String }} payload Login payload
 */
export function loginUser (payload) {
  validateLogin(payload)
  return $axios.post('/auth/login', {
    email: payload.email,
    password: payload.password
  })
}

/**
 * Resets user's password
 * @param {{ email: String }} payload Reset password payload
 */
export function resetUserPassword (payload) {
  validateResetPassword(payload)
  return $axios.post('/auth/resetpassword', {
    data: payload
  })
}

/**
 * Invites a new user
 * @param {String} authToken AuthToken
 * @param {{ email: String, role: String }} user User object
 * @returns {import('axios').AxiosResponse<User>}
 */
export function inviteUser (authToken, payload) {
  useAuthTokenError(authToken)
  validateInviteUser(payload)

  return $axios('/auth/inviteuser', {
    method: 'POST',
    headers: {
      'x-access-token': authToken
    },
    data: payload
  })
}
